import React, { type FC } from "react";
import { AppPaths } from "@app/router/paths";
import { toAppUrl } from "@shared/utils/url/toAppUrl";
import { Button } from "@shared/ui/button";
import "./AppErrorFallback.scss";

interface AppErrorFallbackProps {
    /** Краткое сообщение для пользователя. */
    message?: string;
    /** Перезагрузить страницу. */
    onReload?: () => void;
}

/**
 * Мобильный fallback при необработанной ошибке рендера.
 */
export const AppErrorFallback: FC<AppErrorFallbackProps> = ({
    message = "Произошла ошибка. Попробуйте обновить страницу или вернуться в меню.",
    onReload,
}) => {
    return (
        <div className="app_error_fallback">
            <h1 className="app_error_fallback__title">Ошибка приложения</h1>
            <p className="app_error_fallback__message">{message}</p>
            <div className="app_error_fallback__actions">
                <Button
                    variant="secondary"
                    onClick={() => {
                        const href = toAppUrl(AppPaths.MENU, window);
                        if (href != null) {
                            window.location.assign(href);
                        }
                    }}
                >
                    На главную
                </Button>
                <Button
                    onClick={() => {
                        if (onReload != null) {
                            onReload();
                            return;
                        }
                        window.location.reload();
                    }}
                >
                    Обновить
                </Button>
            </div>
        </div>
    );
};
